<template>
  <div class="card bg-light col-3 m-2 p-4 text-dark d-flex flex-column align-items-center justify-content-center shadow-lg rounded">
    <div style="transform: translateY(-1vw) translateX(-0.5vw)" class="d-flex justify-content-between w-100">
      <p>{{title}}</p>
      <p @click.prevent="closeItem" class="text-danger" style="cursor: pointer;">❌</p>
    </div>
    <hr class="w-100" style="transform: translateY(-2vw)">
    <div v-for="(item, index) in links" :key="index" class="d-flex flex-column align-items-start w-100 mb-2">
      <div>
        <img class="me-2" src="../../assets/img/menu/left-arrow.svg" alt="left-arrow"><router-link :to="item.link" class="text-decoration-none link-info">{{ item.text }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialItemFirst: {
      type: Boolean,
      default: false
    },
    links: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(item => typeof item.link === 'string' && typeof item.text === 'string');
      },

    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    closeItem() {
      this.$emit('update:itemFirst', false);
    }
  }
};
</script>

<style scoped>
/* اضافه کردن استایل‌های دلخواه */
</style>
